import React from 'react';
import { Button } from 'react-bootstrap';

export default function CheckFxRate({currencyFrom, currencyTo, DebitAmount, rate, PaymentAmount, RemittanceFee, submit_function}){
  return (
    <div className="fx">
      <div><span className="name">Transferring </span><b>{currencyTo} {PaymentAmount.toFixed(2)}</b> will cost you <b>{currencyFrom} {DebitAmount.toFixed(2)}</b></div>
      <div><span className="name">Conversion rate: </span><b>{currencyFrom} 1 = {currencyTo} {rate.toFixed(4)}</b></div>
      {RemittanceFee && <div className="name remittance-fee"><span className="name">Remittance fee (not included):</span> <b>{RemittanceFee}</b></div>}
      <Button className="mt-3"
        variant="dark"
        block
        onClick={() => submit_function()}
      >
        Accept
      </Button>
    </div>  
  );
}